<template>
  <div class="father" style="display: inline-block;padding: 0 10px;">
    <div class="left">
      <div class="left-title">
        <el-input
          clearable
          v-model="searchmch_name"
          placeholder="输入店铺名称搜索店铺"
        ></el-input>
        <el-button type="primary" @click="searchMchName">搜索</el-button>
      </div>
      <div v-if="wtytbshow">
        <wty-table
          ref="wtyTableRef"
          :who="'createMerchant'"
          :operate="'查看详细信息'"
          :wtycolumnList="wtycolumnList"
          :wtytbheigh="500"
          :wtytbList="wtytbList"
          @wtyTbreturn="wtyTbreturn"
        ></wty-table>
      </div>
    </div>
    <div class="right">
      <el-scrollbar
        wrapStyle="overflow-x:hidden;"
        style="width: 100%;height: 500px;background-color: #fff;"
      >
        <div class="father">
          <el-form
            label-width="300px"
            style="background-color: #fff; padding:0 20px 0 20px;width: 100%"
            ref="dataFormRef"
            :model="merchant"
            :rules="rules"
            label-position="top"
          >
            <div class="title">
              基本信息
            </div>
            <el-form-item
              label="营业执照（上传营业执照进行识别）"
              prop=""
              style="height:193px;"
              v-if="!modify"
            >
              <!-- <logo
                :wh="
                  'height:160px;width:288.9px;background-color:#80c4ff;font-size:20px;'
                "
                :tag="'yyzz'"
                :serviceupload="true"
                @getReturn="getReturn"
                @returnClose="returnClose"
              >
                <div style="height:160px;width:288.9px'">
                  上传营业执照
                </div>
              </logo> -->
              <uploadImg
                class="uploadImg"
                :imgTitle="'yyzz'"
                @getReturn="getReturn"
                @removeImg="removeImg"
              >
                <template slot="centerName">
                  营业执照
                </template>
              </uploadImg>
            </el-form-item>
            <el-form-item label="店铺状态：" v-model="mch_type" v-if="modify">
              <wty-radio
                @wtyRadioChange="wtyRadioChange"
                :radioList="radioList"
                :checked="merchant.state"
              ></wty-radio>
            </el-form-item>

            <el-form-item label="wx店铺号：" v-if="modify">
              <el-input
                clearable
                v-model="wxMchInfo.wx_mch_no"
                placeholder="请输入微信店铺号"
              >
              </el-input>
            </el-form-item>

            <div v-for="(item, index) in formList" :key="index">
              <div class="title" style="" v-if="index == 8">
                选填信息
              </div>
              <el-form-item :label="item.label" :prop="item.value">
                <el-input
                  clearable
                  :disabled="modify"
                  :show-password="item.value == 'pass_word'"
                  :blur="
                    item.value == 'sub_name'
                      ? subNameBlur(true)
                      : subNameBlur(false)
                  "
                  v-model="merchant[item.value]"
                  :placeholder="`请输入${item.label}`"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-scrollbar>

      <div class="wty-footer">
        <el-button type="danger" @click="resetForm"> 新建 </el-button>
        <el-button v-if="modify" type="primary" @click="saveType">
          保存信息</el-button
        ><el-button v-else type="primary" @click="MerchantGenerate">
          保存
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import wtyRadio from "@/components/wty-radio";
import wtyTable from "@/components/wty-table";
import { payConfigurePay, payGetConfigure } from "@/api/v2/merchant.js";
import uploadImg from "@/components/uploadImg.vue";
import {
  merchantGenerate,
  serviceQueryMerchant,
  merchantSetState,
  getServiceCreateMerchant
} from "@/api/service";
import { testR } from "@/api/common";
let pinyin = require("js-pinyin");
export default {
  name: "createMerchant",
  components: { wtyTable, uploadImg, wtyRadio },
  data() {
    return {
      wxMchInfo: {
        wx_mch_no: ""
      },
      searchmch_name: "",
      mch_type: "正常",
      modify: false,
      wtytbshow: true,
      wtytbList: [],
      formList: [],
      radioList: [
        {
          label: "停业",
          value: "0"
        },
        {
          label: "正常",
          value: "1"
        },
        {
          label: "休息",
          value: "2"
        }
      ],
      wtycolumnList: [],
      merchant: {
        state: "",
        mch_name: "", //店铺名称
        sub_name: "", //店铺简称
        mobile_no: "", //联系人手机号码
        pass_word: "", //登录密码
        license_code: "", //营业执照
        address: "", //店铺地址
        contacts_man: "", //联系人姓名
        e_mail: "", //电子邮箱
        phone: "", //固定电话
        fax: "", //传真号码
        pym: "", //拼音码
        service_phone: "", //服务热线
        mch_type: "01" //店铺类型号
      },

      rules: this.getRules()
    };
  },
  mounted() {
    this.getMearchant();
  },
  methods: {
    searchMchName() {
      this.$refs.wtyTableRef.wtyTableIn(this.searchmch_name);
      this.modify = false;
      this.$refs.dataFormRef.resetFields();
      this.$refs.wtyTableRef.hideRow();
    },
    wtyTbreturn(res) {
      console.log("点击查看店铺详细信息",res);
      this.modify = false;
      this.merchant = { ...res };
      this.merchant.mch_name = res.merchant_name;
      this.$nextTick(() => {
        this.modify = true;
      });
      payGetConfigure(res.merchant_id).then(res => {
        if (this.testR(res)) {
          this.wxMchInfo.wx_mch_no = res.data.resp_data.wx_mch_no;
        }
      });
    },
    getRules() {
      let list = [
        { label: "营业执照号：", value: "license_code", type: "false" },
        { label: "店铺名称：", value: "mch_name", type: "false" },
        { label: "店铺简称：", value: "sub_name", type: "false" },
        { label: "拼音码：", value: "pym", type: "false" },
        { label: "登录密码：", value: "pass_word", type: "false" },
        { label: "联系人手机号码：", value: "mobile_no", type: "false" },
        { label: "服务热线：", value: "service_phone", type: "false" },
        { label: "联系人姓名：", value: "contacts_man", type: "false" },
        { label: "店铺地址：", value: "address", type: "true" },
        { label: "电子邮箱：", value: "e_mail", type: "true" },
        { label: "固定电话：", value: "phone", type: "true" },
        { label: "传真号码：", value: "fax", type: "true" }
        // { label: "店铺类型号：", value: "mch_type", type: "true" }
      ];

      var rules = {};
      var wtycolumnList = [];

      for (let i = 0; i < list.length; i++) {
        if (list[i].type == "false") {
          rules[list[i].value] = [
            {
              required: true,
              message: `请输入${list[i].label}`,
              trigger: "blur"
            }
          ];
        }
        // if (i == 7) break;
      }
      wtycolumnList.push({
        prop: "merchant_id",
        align: "center",
        label: "店铺ID",
        width: "200",
        fixed: "left"
      });
      wtycolumnList.push({
        prop: "merchant_name",
        align: "center",
        label: "店铺名称",
        width: "200",
        fixed: false
      });

      // console.log(wtycolumnList)
      //没有营业执照的rule
      rules.license_code = [
        {
          required: true,
          message: `请上传营业执照照片`,
          trigger: "blur"
        }
      ];
      this.$nextTick(() => {
        this.formList = list;
        this.wtycolumnList = wtycolumnList;
      });
      return rules;
      // console.log(JSON.stringify(rules));
    },
    //获取店铺
    async getMearchant() {
      this.wtytbshow = false;
      const result = await getServiceCreateMerchant();
      if (this.testR(result)) {
        this.wtytbList = result.data.resp_data;
      }
      this.wtytbshow = true;
    },
    //重置内容
    resetForm() {
      const that = this;
      this.$confirm("此操作将清空所有内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.modify = false;
          that.$refs.dataFormRef.resetFields();
          this.$refs.wtyTableRef.hideRow();
          this.successMessage("内容重置成功！");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    removeImg(imgTitle) {
      switch (imgTitle) {
        case "fm":
          // this.img_legal_id_back = "";
          break;
        case "zm":
          // this.img_legal_id_front = "";
          break;
        case "yyzz":
          // this.img_license = "";
          break;
      }
    },
    getReturn(res) {
      if (JSON.stringify(res) == "{}") {
        this.warnMessage("未识别出有效内容，请重试");
      } else {
        this.successMessage("识别成功");
        this.merchant.mch_name = res.commpanyName;
        this.merchant.address = res.address;
        this.merchant.contacts_man = res.legalPerson;
        this.merchant.license_code = res.licenseCode;
      }

      // res.media_no = this.merchant.license_code;
    },
    returnClose(res) {
      console.log(res);
    },
    MerchantGenerate() {
      this.$refs.dataFormRef.validate(async vaild => {
        if (!vaild) {
          return;
        }
        var { ...data } = this.merchant;
        // data.pass_word = await this.$encrypt(this.merchant.pass_word);
        data.pass_word = await this.$encrypt(
          this.merchant.pass_word,
          "pass_word"
        );
        data.mobile_no = await this.$encrypt(
          this.merchant.license_code,
          "mobile_no"
        );
        //TODO: 先传一个测试的营业执照号记得改
        data.license_code = await this.$encrypt(
          this.merchant.license_code,
          "license_code"
        );
        const res = await merchantGenerate(data);
        if (testR(res)) {
          if (
            res.data.result_code == "SUCCESS" &&
            res.data.return_code == "SUCCESS" &&
            res.data.resp_data
          ) {
            this.successMessage("创建店铺成功!");
            this.getMearchant();
          }
        }
      });
    },
    subNameBlur(key) {
      if (key) {
        this.merchant.pym = pinyin.getCamelChars(this.merchant.sub_name);
      }
    },
    async saveType() {
      // console.log(this.merchant.state);
      // console.log(this.merchant.merchant_id);
      const res = await merchantSetState(
        this.merchant.merchant_id,
        this.merchant.state
      );
      if (this.testR(res)) {
        this.successMessage("店铺状态修改成功！");
        /* this.modify = false;
        this.$refs.dataFormRef.resetFields();
        this.$refs.wtyTableRef.hideRow(); */
      }
      if (this.wxMchInfo.wx_mch_no) {
        payConfigurePay(this.wxMchInfo).then(res => {
          if (
            res.data.return_code == "SUCCESS" &&
            res.data.result_code == "SUCCESS"
          ) {
            this.successMessage("wx店铺id修改成功");
          }
        });
      }
    },
    wtyRadioChange(res) {
      console.log(res);
      this.merchant.state = res;
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  border-bottom: 2px solid rgb(0, 89, 184);
  color: rgb(0, 89, 184);
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
}
.left {
  width: 50%;
  min-width: 600px;
  float: left;
  padding-right: 20px;
  .left-title {
    padding: 0 20px;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.right {
  width: 50%;
  min-width: 600px;
  float: left;
}
.el-input {
  width: 400px;
}
.wty-footer {
  height: 50px;
  .el-button {
    width: 200px;
  }
}
</style>
